import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

/**
 * TicketTagSelectorPopupComponent
 *
 * Dialog component for creating new tags.
 * Features color picker and tag name input.
 *
 * @selector app-ticket-tag-selector-popup
 */
@Component({
    selector: 'app-ticket-tag-selector-popup',
    templateUrl: './ticket-tag-selector-popup.component.html',
    styleUrls: ['./ticket-tag-selector-popup.component.scss'],
    standalone: false
})
export class TicketTagSelectorPopupComponent implements OnInit {

  tagForm: FormGroup;

  // Predefined colors for tag selection
  tagColors: string[] = [
    '#ef4444', '#f97316', '#f59e0b', '#eab308',
    '#84cc16', '#22c55e', '#10b981', '#14b8a6',
    '#06b6d4', '#0ea5e9', '#3b82f6', '#6366f1',
    '#8b5cf6', '#a855f7', '#d946ef', '#ec4899',
    '#f43f5e', '#6b7280', '#374151', '#1f2937',
  ];

  selectedColor: string = this.tagColors[0];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TicketTagSelectorPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.tagForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]],
      color: [this.selectedColor, Validators.required],
    });
  }

  ngOnInit(): void {
    if (this.data?.existingTag) {
      this.tagForm.patchValue(this.data.existingTag);
      this.selectedColor = this.data.existingTag.color;
    }
  }

  selectColor(color: string): void {
    this.selectedColor = color;
    this.tagForm.patchValue({ color });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.tagForm.valid) {
      // Return in same format as Task module: { action: 'create', tag: { name, color } }
      this.dialogRef.close({
        action: 'create',
        tag: this.tagForm.value
      });
    }
  }
}
